import axios, {AxiosInstance} from 'axios';

export class BaseApi {
    protected httpClient: AxiosInstance;

    constructor({baseURL}: {baseURL: string}) {
        this.httpClient = axios.create({
            baseURL,
            timeout: 10000,
            transformResponse: this.responseTransformer,
        });
    }

    private responseTransformer(data: any) {
        try {
            const parseData = JSON.parse(data);
            return parseData;
        } catch (error) {
            throw Error(
                `[transformResponse] Error parsing response JSON data - ${error}. Data - ${data}`,
            );
        }
    }
}
